module.exports = __webpack_public_path__ + "static/coast-site-mobile-583c6e4f7fd94bc27a964da896d0cdb2.jpg";